import { defineStore } from 'pinia';

const normalizeCmsItems = (payload) =>
    Array.isArray(payload) ? payload.filter((item) => item && Object.keys(item).length) : payload ? [payload] : [];

const isSiteSettings = (item) =>
    !!item && (item.subscribeRecipients || item.communityLink || item.instagram || item.facebook);

const isWizardSettings = (item) => !!item && (item.wizardLinks || item.wizardProducts);

export const useGlobalStore = defineStore('global', {
    state: () => ({
        settings: [],
        lenis: null,
        pageTransitionBeforeComplete: false,
        pageTransitionComplete: false,
        appLoadingComplete: false,

        //metadata
        geo: {},

        // modals
        employee: {},
        dealerId: null,
        video: null,
        toggleSearchDealer: false,

        // menus 
        menus: [],
        instagramFeed: [],
        mobileMenuToggle: false,
        wizard: {
            step: 1,
            busyIndex: -1,
            show: false
        }
    }),
    actions: {
        setLenis(payload) {
            this.lenis = payload;
        },
        setAppLoadingComplete(payload) {
            this.appLoadingComplete = payload;
        },
        setPageTransitionBeforeComplete(payload) {
            this.pageTransitionBeforeComplete = payload;
        },
        setPageTransitionComplete(payload) {
            this.pageTransitionComplete = payload;
        },
        setPageWithHero(payload) {
            this.pageWithHero = payload
        },
        setSettings(payload) {
            const items = normalizeCmsItems(payload);
            const siteSettings = items.find(isSiteSettings) || items[0] || null;
            const currentWizardSettings = normalizeCmsItems(this.settings).find(isWizardSettings) || null;

            this.settings = [siteSettings, currentWizardSettings].filter(Boolean);
        },
        setWizardSettings(payload) {
            const items = normalizeCmsItems(payload);
            const wizardSettings = items.find(isWizardSettings) || items[0] || null;
            const currentSiteSettings = normalizeCmsItems(this.settings).find(isSiteSettings) || this.settings[0] || null;

            this.settings = [currentSiteSettings, wizardSettings].filter(Boolean);
        },
        setEmployee(payload) {
            this.employee = payload;
        },
        setDealerId(payload) {
            this.dealerId = payload;
        },
        setVideo(payload) {
            this.video = payload
        },
        setSearchDealer(payload) {
            this.toggleSearchDealer = payload;
        },
        setMenus(payload) {
            this.menus = payload;
        },
        setToggleMobileMenu(payload) {
            this.mobileMenuToggle = payload;
        },
        setInstagramFeed(payload) {
            this.instagramFeed = payload;
        },
        setGeoData(payload) {
            this.geo = payload;
        },
        setWizard(payload) {
            this.wizard.show = payload;
        },
        setWizardStep(payload) {
            this.wizard.step = payload;
        },
        setWizardBusyIndex(payload) {
            this.wizard.busyIndex = payload;
        },
        toggleMobileMenu() {
            this.mobileMenuToggle = !this.mobileMenuToggle;
        }
    },
})
